export const UserRole = {
  ADMIN: 'ADMIN',
  OWNER: 'OWNER',
  EMPLOYEE: 'EMPLOYEE'
};

export const UserType = {
  SIMPLE: 'SIMPLE',
  COMPLEX: 'COMPLEX'
};

export const MovementCategory = {
  OPERATIONAL: 'OPERATIONAL',
  INTERNAL: 'INTERNAL'
};

export const MovementType = {
  VENDA: 'VENDA',
  SERVICO: 'SERVICO',
  GAS: 'GAS'
};

export const ServiceCategory = {
  AR_CONDICIONADO: 'AR_CONDICIONADO',
  PAINEL_SOLAR: 'PAINEL_SOLAR',
  OUTROS: 'OUTROS'
};

export const PaymentMethod = {
  CASH: 'CASH',
  CARD: 'CARD',
  TRANSFER: 'TRANSFER',
  CHEQUE: 'CHEQUE',
  PENDING: 'PENDING',
  VOUCHER: 'VOUCHER',
  MBWAY: 'MBWAY'
};

// Nota: Em JavaScript, usamos objetos simples em vez de interfaces
// Estas são definições de tipos para referência - os objetos reais devem corresponder a estas estruturas

